import { render } from "./Navbar.vue?vue&type=template&id=3f637fda&scoped=true"
const script = {}

import "./Navbar.vue?vue&type=style&index=0&id=3f637fda&scoped=true&lang=scss"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f637fda"]])

export default __exports__